// components/Projects.js
import React from 'react';

const Projects = () => {
  const projects = [
    {
      title: "20KW Roof Top On-Grid System",
      client: "UNFPA",
      year: "2021",
      description: "Designed and installed for Zomba Statistical Office to power servers and air conditioning systems.",
      image: "/images/2.jpg"
    },
    {
      title: "10kw solar off-grid system with a solar drier in Mangochi",
      client: "Christian Aid",
      year: "2021",
      description: "Installed Roof Top 9x10KW Solar & Wind hybrid Power off-grid system for solar driers and fridges in Mangochi & Kalonga Districts.",
      image: "/images/3.jpg"
    },
      {
      title: "12 KW off- grid system for kasupe trust Mangochi",
      client: "Kasupe Trust",
      year: "2022",
      description: "Designed & installed ground mounted 30KW initial system (upgradable to 100KW) solar power off-grid system to power Administration Block, 8 classroom blocks, and a village for Kasupe Trust in Mangochi.",
      image: "/images/20.jpg"
    },
    
    // Add other projects as needed
  ];

  return (
    <section id="projects" className="projects">
      <div className="container">
        <div className="section-title">
          <h2>Our Projects</h2>
          <p>Successfully completed solar energy projects for various clients across Malawi and beyond.</p>
        </div>
        <div className="projects-grid">
          {projects.map((project, index) => (
            <div key={index} className="project-card">
              <div className="project-image">
                <img 
                  src={project.image} 
                  alt={project.title}
                  className="project-img"
                  onError={(e) => {
                    // Fallback if image fails to load
                    e.target.style.display = 'none';
                    const fallbackDiv = document.createElement('div');
                    fallbackDiv.className = 'image-fallback';
                    fallbackDiv.innerHTML = `<p>${project.title}</p>`;
                    e.target.parentNode.appendChild(fallbackDiv);
                  }}
                />
              </div>
              <div className="project-content">
                <h3>{project.title}</h3>
                <div className="project-meta">
                  <span className="client">{project.client}</span>
                  <span className="year">{project.year}</span>
                </div>
                <p>{project.description}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Projects;